export class coaching {
  id: number;
  name: string;
}
